import axios from "axios";
import { BE_URL } from "../urlUtils";
import { EndpointsConstants } from "../../components/Constants";
import { getOrCreateStickySessionId } from "../stickySessionIdManager";
export async function fetchTermsAndCondition(accessToken) {
  const stickySessionId = await getOrCreateStickySessionId();
  const myHeaders = {
    "Content-Type": "text/plain",
  };
  const myParams = {
    "x-sticky-session-id": stickySessionId,
  };
  const json = await axios.post(
    BE_URL + EndpointsConstants.FETCH_TERMS_ENDPOINT,
    accessToken,
    { headers: myHeaders, params: myParams },
  );

  return json.data;
}
